import { render, staticRenderFns } from "./StatisticsForm.vue?vue&type=template&id=b750fe30"
import script from "./StatisticsForm.vue?vue&type=script&lang=js"
export * from "./StatisticsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports